import type { NearbyResult } from "../hooks/useNearbyEntities";
import type { EntityType } from "../types";
import { isContainerEntityType } from "./activityLogging";

/** Close enough to a ride, restaurant or show to say you're at it. */
export const BEST_GUESS_PLACE_M = 100;
/** Close enough to a park or hotel's pin to say you're there. */
export const BEST_GUESS_CONTAINER_M = 500;

/**
 * The place the Log sheet leads with: the nearest ride, restaurant or show
 * within a short walk, else the park (or hotel) you're at but haven't checked
 * into. Places with an activity still open are skipped, since you're already
 * logging them. Null when nothing is close enough to be a fair guess.
 */
export function pickBestGuess<T extends { id: string; type: EntityType }>(
  nearby: NearbyResult<T>[],
  openEntityIds: ReadonlySet<string>,
): NearbyResult<T> | null {
  const free = nearby.filter((n) => !openEntityIds.has(n.entity.id));
  return (
    free.find((n) => !isContainerEntityType(n.entity.type) && n.distanceMeters <= BEST_GUESS_PLACE_M) ??
    free.find((n) => isContainerEntityType(n.entity.type) && n.distanceMeters <= BEST_GUESS_CONTAINER_M) ??
    null
  );
}
